import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { Utils } from 'src/modules/utils/shared/utils';
import { TableColumn } from '../../models/table-column.model';

@Component({
  selector: 'sm-table-header',
  templateUrl: './sm-table-header.component.html',
  styleUrl: './sm-table-header.component.scss'
})
export class SmTableHeaderComponent implements IHeaderAngularComp {

    _Utils = Utils;

    app = inject(MainAppService);

    params: IHeaderParams & any;

    @ViewChild('menuButton', { read: ElementRef }) public menuButton!: ElementRef;

    agInit(params: IHeaderParams): void {
        this.params = params;
    }

    isFirstColumn(): boolean {
        return Utils.arrayGetSafe(this.params.api.getAllDisplayedColumns() as [], 0) == this.params.column;
      }

    menuClicked(event: any): void {
        this.params.context.table.openSettings(event);
        event.stopPropagation();
        event.preventDefault();
    }

    columnMenuClicked(event: any): void {
        this.openColumnSettings(event);
        event.stopPropagation();
        event.preventDefault();
    }

    sortRequested(event: any): void {
        if (this.params.column.colDef.sortable) {
            this.params.setSort((this.params.column as any).sort == "asc" ? "desc" : "asc", event.shiftKey);
        }
    }

    refresh(params: any): boolean {
        this.agInit(params);
        return true;
    }

    openColumnSettings(event: any): void {
        this.app.openContextMenu([
            this.params.column.pinned != "left" ? {
                label: this.app.t("table.pinLeft"),
                command: () => this.pinLeft(event)
            } : null,
            this.params.column.pinned == "left" ? {
                label: this.app.t("table.unpin"),
                command: () => this.unpin(event)
            } : null
        ]);
        event.stopPropagation();
    }

    pinLeft(event: any) :void {
        this.params.api.applyColumnState({
            state: [{ colId: this.params.column.colId, pinned: "left" }]
          });
    }

    unpin(event: any) :void {
        this.params.api.applyColumnState({
            state: [{ colId: this.params.column.colId, pinned: null }]
          });
    }

    click(event: any): void {
        let tc = this.params.column.colDef.context.tableColumn as TableColumn;
        if (tc.headerClicked == null || !tc.headerClicked(tc.id)) {
            event.stopPropagation();
            event.preventDefault();
        }
    }
}
